import { render, staticRenderFns } from "./tvChannel.vue?vue&type=template&id=6c6e2a67"
import script from "./tvChannel.vue?vue&type=script&lang=js"
export * from "./tvChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports